<template>
  <div class="w-100">
    <h1 class="mb-4">Create meta data</h1>

    <div class="form">
      <label for="">Language:</label>
      <div class="form-row">
        <div class="form-group col-lg-6">
          <select
              v-model="form.language"
              class="form-control"
          >
            <option
                v-for="lang in languages"
                :value="lang.code"
                v-bind:key="lang.code"
            >
              {{ lang.title }}
            </option>
          </select>
        </div>
      </div>
      <label for="">Type:</label>
      <div class="form-row">
        <div class="form-group col-lg-6">
          <select
              v-model="subjectType"
              @change="onSubjectTypeChange()"
              class="form-control"
          >
            <option
                v-for="type in subjectTypes"
                :value="type"
                v-bind:key="type.title"
            >
              {{ type.title }}
            </option>
          </select>
        </div>
      </div>

      <!-- حالت معمولی: یه انتخاب تکی (products, categories, cities, home, aboutUs) -->
      <template v-if="!isCityCategory">
        <label class="typo__label" for="ajax">Search for Item</label>
        <div class="form-row">
          <div class="form-group col-lg-6">
            <multiselect v-model="selectedSubject" @input="loadMeta($event)" id="ajax" label="title" track-by="id" placeholder="Type to search"
                         open-direction="bottom" :options="subjects" :multiple="false" :searchable="true" :loading="isLoading"
                         :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                         :limit="3" :max-height="600" :show-no-results="false" :hide-selected="true"
                         @search-change="asyncFind">
              <template #tag="{ option, remove }"><span class="custom__tag"><span>{{ option.name }}</span><span
                  class="custom__remove" @click="remove(option)">❌</span></span></template>
              <template #clear="props">
                <div class="multiselect__clear" v-if="selectedSubject.length"
                     @mousedown.prevent.stop="clearAll(props.search)"></div>
              </template>
              <template #noResult>
                <span>Oops! No elements found. Consider changing the search query.</span>
              </template>
            </multiselect>
          </div>
        </div>
      </template>

      <!-- حالت cityCategory: باید هم دسته هم شهر انتخاب بشه -->
      <template v-else>
        <label class="typo__label" for="ajax-category">Category</label>
        <div class="form-row">
          <div class="form-group col-lg-6">
            <multiselect v-model="selectedCategory" @input="onCityCategoryChange" id="ajax-category" label="title" track-by="id"
                         placeholder="Select a category" open-direction="bottom" :options="categoryOptions" :multiple="false"
                         :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true"
                         :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="true">
              <template #noResult>
                <span>Oops! No elements found.</span>
              </template>
            </multiselect>
          </div>
        </div>

        <label class="typo__label" for="ajax-city">City</label>
        <div class="form-row">
          <div class="form-group col-lg-6">
            <multiselect v-model="selectedCity" @input="onCityCategoryChange" id="ajax-city" label="name" track-by="id"
                         placeholder="Select a city" open-direction="bottom" :options="cityOptions" :multiple="false"
                         :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true"
                         :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="true">
              <template #noResult>
                <span>Oops! No elements found.</span>
              </template>
            </multiselect>
          </div>
        </div>
      </template>

      <div v-if="canGenerate" class="mb-4">
        <button class="btn btn-primary" @click="generateMetaData">Generate metadata with AI</button>

        <div v-if="metaDataLoading">Generating metadata with chat gpt...</div>
      </div>

      <label for="">Meta title:</label>
      <div class="form-row">
        <div class="form-group col-lg-12">
          <input
              :readonly="waitToGettingData"
              v-model="form.title"
              class="form-control"
              placeholder="Title"
          />
        </div>
      </div>

      <label for="">Meta description:</label>
      <div class="form-row">
        <div class="form-group col-lg-12">
          <input
              :readonly="waitToGettingData"
              v-model="form.description"
              class="form-control"
              placeholder="Description"
          />
        </div>
      </div>

      <ul style="padding-left: 20px; margin-top: 20px">
        <li v-for="error in errors" v-bind:key="error" class="text-danger">
          {{ error }}
        </li>
      </ul>

      <button type="submit" class="btn btn-success pl-4 pr-4" @click="submit()" :disabled="!canSubmit">
        Create
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "../../../helpers";
import metadataOptions from "@/static/metadata.json"
import Multiselect from 'vue-multiselect'
export default {
  name: "MetaDataCreate",
  components: {
    Multiselect
  },
  data() {
    return {
      languages: [],
      searchable: true,
      subjectTypes: metadataOptions,

      subjects: [],

      experiences: [],
      selectedSubject: '',
      isLoading: false,
      waitToGettingData: false,

      subjectType: null,
      subjectId: 0,
      metaDataLoading: false,

      // [NEW] state مخصوص حالت cityCategory
      categoryOptions: [],
      cityOptions: [],
      selectedCategory: null,
      selectedCity: null,

      form: {
        title: null,
        description: null,
        language: null
      },
      errors: [],
    };
  },
  mounted() {
    this.getLanguages()
  },

  computed: {
    // [NEW]
    isCityCategory() {
      return this.subjectType?.title === 'cityCategory';
    },
    canGenerate() {
      if (this.isCityCategory) {
        return !!this.selectedCategory && !!this.selectedCity;
      }
      return this.subjectId != null && this.subjectId !== 0;
    },
    canSubmit() {
      if (this.isCityCategory) {
        return !!this.selectedCategory && !!this.selectedCity;
      }
      return true;
    },
  },

  watch: {
    selectedSubject: function (val) {
      this.subjectId = val.id;
    },
  },

  methods: {
    // [NEW] city_id + category_id -> composite id (باید دقیقاً با
    // MetaDataTypes::encodeCityCategoryId توی بک‌اند یکی باشه)
    cityCategoryId(cityId, categoryId) {
      return cityId * 1000000 + categoryId;
    },

    async getLanguages() {
      await axios.get(config("BACKEND_ROOT") + "/admin/languages").then((response) => {
        this.languages = response.data.data;
      });
    },

    // [NEW] وقتی نوع عوض می‌شه، اگه رفتیم روی cityCategory، هر دو لیست
    // (دسته و شهر) رو جدا بارگذاری می‌کنیم؛ وگرنه رفتار قبلی (loadSubjects)
    onSubjectTypeChange() {
      this.form.title = null;
      this.form.description = null;
      this.selectedCategory = null;
      this.selectedCity = null;
      this.selectedSubject = '';
      this.subjectId = 0;

      if (this.isCityCategory) {
        this.loadCityCategoryOptions();
      } else {
        this.loadSubjects();
      }
    },

    // [NEW]
    loadCityCategoryOptions() {
      axios
          .get(`${config("BACKEND_ROOT")}/admin/categories`)
          .then((response) => {
            this.categoryOptions = response.data.data;
          });
      axios
          .get(`${config("BACKEND_ROOT")}/admin/client-cities`)
          .then((response) => {
            this.cityOptions = response.data.data;
          });
    },

    // [NEW] هر دو انتخاب پر شدن، متادیتای فعلی (اگه از قبل ثبت شده) رو می‌گیریم
    onCityCategoryChange() {
      if (!this.selectedCategory || !this.selectedCity) return;

      const id = this.cityCategoryId(this.selectedCity.id, this.selectedCategory.id);

      this.waitToGettingData = true;
      axios
          .get(`${config("BACKEND_ROOT")}/admin/meta-data/cityCategory/${id}`, {
            params: { lang: this.form.language },
          })
          .then((response) => {
            this.form.title = response.data.data?.title;
            this.form.description = response.data.data?.description;
            this.waitToGettingData = false;
          })
          .catch(() => {
            this.waitToGettingData = false;
          });
    },

    loadMeta(selected){
      this.waitToGettingData = true;
      axios.get(`${config("BACKEND_ROOT")}/admin/meta-data/${this.subjectType.title}/${selected.id}?lang=${this.form.language}`).then((response) => {
        this.form.title = response.data.data?.title
        this.form.description = response.data.data?.description
        this.waitToGettingData = false;
      });
    },
    asyncFind (query) {
      this.isLoading = true

      this.subjects = [];
      if(this.subjectType.value !== 0) {
        if (this.subjectType.extra_data) {
          this.subjects.push(this.subjectType.extra_data);
        }
      }


      axios
          .get(`${config("BACKEND_ROOT")}/admin/${this.subjectType.title}`, { params: { 'filters[title]': query }})
          .then((response) => {
            this.subjects =[...this.subjects,...response.data.data];
            this.isLoading = false
          })
          .catch((err) => {
          });
    },
    clearAll () {
      this.selectedSubject = ''
    },

    loadSubjects() {
      this.subjects = [];
      if(this.subjectType.value != 0){
        if(this.subjectType.extra_data){
          this.subjects.push(this.subjectType.extra_data);
        }

        if(this.subjectType.title !== 'products' || this.subjectType.title !== 'aboutUs'){
          this.searchable = false

          let dataEndPoint = this.subjectType.title;
          if(this.subjectType.title == 'cities'){
            dataEndPoint = 'client-cities';
          }
          axios
              .get(`${config("BACKEND_ROOT")}/admin/${dataEndPoint}`)
              .then((response) => {
                this.subjects =[...this.subjects,...response.data.data];
                this.isLoading = false
              })
              .catch((err) => {
              });
        }

      }
      else{
        this.subjects = [];
        this.subjects.push({'id' : this.subjectType.value, 'title': this.subjectType.title});
      }
    },

    async generateMetaData() {
      this.metaDataLoading = true;

      if (this.isCityCategory) {
        const id = this.cityCategoryId(this.selectedCity.id, this.selectedCategory.id);
        axios.post(
            `${config("BACKEND_ROOT")}/admin/meta-data/cityCategory/${id}/ai`,
            { language: this.form.language ?? 'en' }
        ).then((response) => {
          const res = response.data.data;
          this.form.title = res.title;
          this.form.description = res.description;
          this.metaDataLoading = false;
        }).catch((error) => {
          console.error('Error:', error);
          this.metaDataLoading = false;
        });
        return;
      }

      var type = this.subjectType.title;
      if (this.subjectType.title === 'home'){
        var id = 0;
      }else{
        id = this.subjectId;
      }

      axios.post(`${config("BACKEND_ROOT")}/admin/meta-data/${type}/${id}/ai`, {
        'language': this.form.language ?? 'en',
      }).then((response) => {
        var res = response.data.data;
        this.form.title = res.title;
        this.form.description = res.description;
        this.metaDataLoading = false;
      }).catch((error) => {
        console.error('Error:', error);
      });
    },

    submit() {
      // [NEW] مسیر متفاوت برای cityCategory، با composite id
      if (this.isCityCategory) {
        const id = this.cityCategoryId(this.selectedCity.id, this.selectedCategory.id);
        axios
            .post(`${config("BACKEND_ROOT")}/admin/meta-data/cityCategory/${id}`, this.form)
            .then(() => {
              this.$router.push("/meta-data");
            })
            .catch((error) => {
              this.errors = Object.values(error.response.data.errors).flat();
            });
        return;
      }

      axios
          .post(
              `${config("BACKEND_ROOT")}/admin/meta-data/${this.subjectType.title}/${
                  this.subjectId
              }`,
              this.form
          )
          .then((response) => {
            this.$router.push("/meta-data");
          })
          .catch((error) => {
            this.errors = Object.values(error.response.data.errors).flat();
          });
    },
  },
};
</script>